import '../styles/PartnersSection.css';

const PARTNERS = [
  { name: 'Elliptic', file: 'elliptic.webp' },
  { name: 'LayerZero', file: 'layerzero.webp' },
  { name: 'Hypernative', file: 'hypernative.webp' },
  { name: 'Ankr', file: 'ankr.webp' },
  { name: 'Arkham', file: 'arkham.webp' },
  { name: 'HexTrust', file: 'hextrust.webp' },
  { name: 'QuickNode', file: 'quicknode.webp' },
];

function PartnersSection() {
  return (
    <section className="partners">
      <p className="partners__label">Building with the best</p>
      <div className="partners__grid">
        {PARTNERS.map((partner) => (
          <img
            key={partner.name}
            src={`${process.env.PUBLIC_URL}/images/${partner.file}`}
            alt={partner.name}
            className="partners__logo"
          />
        ))}
      </div>
    </section>
  );
}

export default PartnersSection;